import { isObject } from "lodash";

interface MemberWithDmStatus {
  can_receive_dm_from_current_member?: boolean;
  id?: number;
}

export const useCanMessageMember = ({
  shouldHideMessageButton = false,
}: {
  shouldHideMessageButton?: boolean;
} = {}) => {
  const shouldShowMessageOption = (receiverMember?: MemberWithDmStatus) => {
    if (!isObject(receiverMember)) {
      return false;
    }

    if (shouldHideMessageButton) {
      return false;
    }

    return Boolean(receiverMember.can_receive_dm_from_current_member);
  };

  return { shouldShowMessageOption };
};
